import { toDateTime } from "Helpers/Format";

export const downloadColumns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome do Usuário",
    accessor: "full_name",
  },
  {
    Header: "Visualizado em",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];

export const columns = [
  {
    Header: "ID",
    accessor: "id",
  },
  {
    Header: "Nome do Usuário",
    accessor: "full_name",
  },
  {
    Header: "Visualizado em",
    accessor: (row) => (row.created_at ? toDateTime(row.created_at) : ""),
  },
];
